/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_EncryptInputs */

const en_pc_cmp_r_encrypt = /** @type {(inputs: Pc_Cmp_R_EncryptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwords and redaction`)
};

const zh_pc_cmp_r_encrypt = /** @type {(inputs: Pc_Cmp_R_EncryptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码与涂黑`)
};

/**
* | output |
* | --- |
* | "Passwords and redaction" |
*
* @param {Pc_Cmp_R_EncryptInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_encrypt = /** @type {((inputs?: Pc_Cmp_R_EncryptInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_EncryptInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_encrypt(inputs)
	return zh_pc_cmp_r_encrypt(inputs)
});
export { pc_cmp_r_encrypt as "pc.cmp.r.encrypt" }